<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-panel-body v-if="status !== 'loading'" >
                <product-form :submit="updateProduct" :query="product"></product-form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { productService } from '@/common/api.service'
import productForm from './components/form'
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'

export default {
    components: {
        mainContent,
        productForm,
    },
    computed: {
        ...mapGetters('product', [
            'product', 'status'
        ])
    },
    data() {
        return {
            hashid: this.$route.params.hashid,
            store_hashid: this.$route.params.store_hashid
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('product/find', vm.hashid)
        })
    },
    methods: {
        updateProduct(e, query) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                rules: {
                    title: {
                        required: true,
                    },
                    amount: {
                        required: true,
                    },
                    quantity: {
                        required: true,
                    },
                    description: {
                        required: true,
                    },
                },
            });


            if(!form.valid()) {
                return
            }

            query['store_id'] = this.store_hashid

            KTApp.progress(btn)
            productService.update(this.hashid, query)
            .then(response => {
                this.$router.push('/stores/'+this.store_hashid+'/products')
                this.showMsg(form, 'success', response.data.message)
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTUtil.scrollTop()
                KTApp.unprogress(btn)
            })
        }
    }
}
</script>